if (!customElements.get('p2r-rider-stories')) {
  class P2RRiderStories extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.p2r-rider-stories__track');
      this.cards = Array.from(this.querySelectorAll('.p2r-rider-story'));
      this.previousButton = this.querySelector('.p2r-rider-stories__button--previous');
      this.nextButton = this.querySelector('.p2r-rider-stories__button--next');
      this.status = this.querySelector('.p2r-rider-stories__status');
      this.activeIndex = 0;

      if (!this.track || this.cards.length < 2) return;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.handlePrevious = () => this.goTo(this.activeIndex - 1);
      this.handleNext = () => this.goTo(this.activeIndex + 1);
      this.handleKeydown = (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.handlePrevious();
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.handleNext();
        }
      };
      this.handleScroll = () => {
        if (this.scrollFrame) return;

        this.scrollFrame = window.requestAnimationFrame(() => {
          this.scrollFrame = null;
          this.syncActiveIndex();
        });
      };

      this.previousButton?.addEventListener('click', this.handlePrevious);
      this.nextButton?.addEventListener('click', this.handleNext);
      this.track.addEventListener('keydown', this.handleKeydown);
      this.track.addEventListener('scroll', this.handleScroll, { passive: true });

      this.resizeObserver = new ResizeObserver(() => this.syncActiveIndex());
      this.resizeObserver.observe(this.track);
      this.updateControls();
    }

    disconnectedCallback() {
      this.previousButton?.removeEventListener('click', this.handlePrevious);
      this.nextButton?.removeEventListener('click', this.handleNext);
      this.track?.removeEventListener('keydown', this.handleKeydown);
      this.track?.removeEventListener('scroll', this.handleScroll);
      this.resizeObserver?.disconnect();
      if (this.scrollFrame) window.cancelAnimationFrame(this.scrollFrame);
    }

    goTo(index) {
      const targetIndex = Math.max(0, Math.min(index, this.cards.length - 1));
      const targetCard = this.cards[targetIndex];

      if (!targetCard) return;

      this.activeIndex = targetIndex;
      this.track.scrollTo({
        left: targetCard.offsetLeft - this.track.offsetLeft,
        behavior: this.reducedMotion.matches ? 'auto' : 'smooth'
      });
      this.updateControls();
    }

    syncActiveIndex() {
      const trackStart = this.track.offsetLeft;
      let closestIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;

      this.cards.forEach((card, index) => {
        const cardStart = card.offsetLeft - trackStart;
        const distance = Math.abs(cardStart - this.track.scrollLeft);

        if (distance < closestDistance) {
          closestIndex = index;
          closestDistance = distance;
        }
      });

      this.activeIndex = closestIndex;
      this.updateControls();
    }

    updateControls() {
      const lastCard = this.cards[this.cards.length - 1];
      const reachedEnd = lastCard.offsetLeft + lastCard.offsetWidth <= this.track.scrollLeft + this.track.clientWidth + 2;

      if (this.previousButton) this.previousButton.disabled = this.activeIndex === 0;
      if (this.nextButton) this.nextButton.disabled = reachedEnd;
      if (this.status) {
        const template = this.status.dataset.statusTemplate || 'Story CURRENT of TOTAL';
        this.status.textContent = template
          .replace('CURRENT', String(this.activeIndex + 1))
          .replace('TOTAL', String(this.cards.length));
      }
    }
  }

  customElements.define('p2r-rider-stories', P2RRiderStories);
}
